import { categories } from "@/mocks/doujin";

export default function Categories() {
  return (
    <section id="categories" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-24">
      <div className="mb-10 flex flex-col items-start justify-between gap-4 md:mb-12 md:flex-row md:items-end">
        <div>
          <span className="text-sm font-medium tracking-wide text-secondary-600">六大分类</span>
          <h2 className="font-heading mt-2 text-2xl text-foreground-950 md:text-4xl">主题分类，查找一目了然</h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            不同形式的同人作品分门别类整理，按你的阅读偏好轻松找到心仪的内容。
          </p>
        </div>
        <button
          onClick={() => document.querySelector("#works")?.scrollIntoView({ behavior: "smooth" })}
          className="cursor-pointer whitespace-nowrap rounded-full border border-primary-300 px-5 py-2.5 text-sm text-primary-700 transition-colors hover:bg-primary-100"
        >
          去热门推荐
          <i className="ri-arrow-right-line ml-1" />
        </button>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((c, idx) => (
          <a
            key={c.id}
            href="#works"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#works")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="group relative block cursor-pointer overflow-hidden rounded-2xl border border-background-200 bg-background-50"
          >
            <div className="relative h-44 w-full overflow-hidden md:h-52">
              <img
                src={c.image}
                alt={`${c.name}分类同人作品`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/45 to-transparent" />
              <span className="absolute right-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs text-primary-700">
                {c.count} 部
              </span>
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg text-foreground-950 md:text-xl">{c.name}</h3>
                <i className="ri-arrow-right-up-line text-lg text-primary-500 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </div>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
            </div>
            {idx % 3 === 2 && (
              <span className="pointer-events-none absolute -right-8 -top-8 h-24 w-24 rounded-full bg-secondary-100/60" />
            )}
          </a>
        ))}
      </div>
    </section>
  );
}